var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "padding-top": ".98rem" } }, [
    _c("div", { staticClass: "topbar-wrapper" }, [
      _c("div", { staticClass: "topbar" }, [
        _c("span", { staticClass: "back", on: { click: _vm.back } }),
        _vm._v("\n            放松助眠\n        ")
      ])
    ]),
    _vm._v(" "),
    _c("audio", {
      ref: "player",
      attrs: {
        src: _vm.fileUrl + _vm.musicDetail.sourceUrl,
        id: "main-audio",
        autoplay: ""
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "musicBg" }, [
      _vm.musicDetail.picUrl != undefined
        ? _c("img", {
            attrs: { src: _vm.EnvUrl + _vm.musicDetail.picUrl, alt: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "progressBox" }, [
        _vm._v("\n            " + _vm._s(_vm.cTime) + "\n            "),
        _c("div", { ref: "runfatbar", staticClass: "progress" }, [
          _c("div", { ref: "runbar", staticClass: "greenbar" }, [
            _c("span", { staticClass: "yuan", attrs: { draggable: "true" } })
          ])
        ]),
        _vm._v("\n            " + _vm._s(_vm.dTime) + "\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "playBox" }, [
        _c("div", { staticClass: "loop" }),
        _vm._v(" "),
        _c("div", { staticClass: "prev", on: { click: _vm.prev } }),
        _vm._v(" "),
        _vm.play
          ? _c("div", { staticClass: "playBtn", on: { click: _vm.playMusic } })
          : _c("div", {
              staticClass: "pauseBtn",
              on: { click: _vm.pauseMusic }
            }),
        _vm._v(" "),
        _c("div", { staticClass: "next", on: { click: _vm.next } }),
        _vm._v(" "),
        _c("div", {
          staticClass: "catalog",
          on: {
            click: function($event) {
              _vm.catalogStatus = true
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _vm.catalogStatus
      ? _c(
          "div",
          {
            staticClass: "mask",
            on: {
              click: function($event) {
                _vm.catalogStatus = false
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "catalogBox" },
              [
                _c("div", { staticClass: "catalogTitle" }, [
                  _vm._v("播放列表 "),
                  _c("div", {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        _vm.catalogStatus = false
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _vm._l(_vm.musicList, function(item, i) {
                  return _c(
                    "div",
                    {
                      staticClass: "catalogItem",
                      class: { active: _vm.index === i },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.select(i)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.name) +
                          "\n                "
                      ),
                      _vm.index === i
                        ? _c("div", { staticClass: "playStyle" })
                        : _vm._e()
                    ]
                  )
                })
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "musicBox" }, [
      _c("div", { staticClass: "con-p" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2d5c076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2d5c076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/music.vue
// module id = null
// module chunks = 